import axios from 'axios';

const auth = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
})

// console.log("BASE_URI!:" + process.env.VUE_APP_API_URL)
export default auth